import React from 'react';
import { useTranslation } from "react-i18next";
import { useSettingsMenu } from '../hooks/useSettingsMenu';
import { MenuSectionRenderer } from '../components/MenuSectionRenderer';
import { UdiSoftwareLabel } from '../components';
import { MainLayout } from '@shared/components/md-design-system/Layout/MainLayout';

const Settings = () => {
  const { t } = useTranslation();
  const { menuSections } = useSettingsMenu();

  return (
    <MainLayout title={t('screens.profile.mainScreen.title')} scrollable>
      <MenuSectionRenderer sections={menuSections} />
      <UdiSoftwareLabel />
    </MainLayout>
  );
};
export { Settings };